require('./bootstrap');
require('es6-promise').polyfill()

window.Vue = require('vue')
import { createApp } from 'vue'

import store from './store/'

import AlternateContactList from './components/alternateContacts/AlternateContactList.vue'
import AppointmentCalendar from './components/appointments/AppointmentCalendar.vue'
import AppointmentDetail from './components/appointments/AppointmentDetail.vue'
import AppointmentSidebar from './components/appointments/AppointmentSidebar.vue'
import CommLogFormControl from './components/communications/CommLogFormControl.vue'
import CommLogForm from './components/communications/CommLogForm.vue'
import CommLogList from './components/communications/CommLogList.vue'
import ConsentDetail from './components/consents/ConsentDetail.vue'
import CoreVisitHistoryReport from './components/coreVisitHistoryReport/CoreVisitHistoryReportManager.vue'
import NoteList from './components/notes/NoteList.vue'
import SubstudyDetail from './components/substudies/SubstudyDetail.vue'
import SchedulingReport from './components/schedulingReport/SchedulingReportManager.vue'
import UserList from './components/users/UserList.vue'

const alternateContactListEl = document.querySelector('#alternate-contact-list')
if (alternateContactListEl) {
	const alternateContactListApp = Vue.createApp({}).use(store)
	alternateContactListApp.component('alternate-contact-list', AlternateContactList)
	alternateContactListApp.mount(alternateContactListEl)
}

const appointmentCalendarEl = document.querySelector('#appointment-calendar')
if (appointmentCalendarEl) {
	const appointmentCalendarApp = Vue.createApp({})
	appointmentCalendarApp.component('appointment-calendar', AppointmentCalendar)
	appointmentCalendarApp.mount(appointmentCalendarEl)
}

const appointmentDetailEl = document.querySelector('#appointment-detail')
if (appointmentDetailEl) {
	const appointmentDetailApp = Vue.createApp({})
	appointmentDetailApp.component('appointment-detail', AppointmentDetail)
	appointmentDetailApp.mount(appointmentDetailEl)
}

const appointmentSidebarEl = document.querySelector('#appointment-sidebar')
if (appointmentSidebarEl) {
	const appointmentSidebarApp = Vue.createApp({})
	appointmentSidebarApp.component('appointment-sidebar', AppointmentSidebar)
	appointmentSidebarApp.mount(appointmentSidebarEl)
}

const commLogListEl = document.querySelector('#comm-log-list')
if (commLogListEl) {
	const commLogListApp = Vue.createApp({}).use(store)
	commLogListApp.component('comm-log-list', CommLogList)
	commLogListApp.mount(commLogListEl)
}

const commLogFormControlEl = document.querySelector('#comm-log-form-control')
if (commLogFormControlEl) {
	const commLogFormControlApp = Vue.createApp({}).use(store)
	commLogFormControlApp.component('comm-log-form-control', CommLogFormControl)
	commLogFormControlApp.mount(commLogFormControlEl)
}

const commLogFormEl = document.querySelector('#comm-log-form')
if (commLogFormEl) {
	const commLogFormApp = Vue.createApp({}).use(store)
	commLogFormApp.component('comm-log-form', CommLogForm)
	commLogFormApp.mount(commLogFormEl)
}

const consentDetailEl = document.querySelector('#consent-detail')
if (consentDetailEl) {
	const consentApp = Vue.createApp({}).use(store)
	consentApp.component('consent-detail', ConsentDetail)
	consentApp.mount(consentDetailEl)
}

const coreVisitHistoryReportEl = document.querySelector('#core-visit-history-report')
if (coreVisitHistoryReportEl) {
	const coreVisitHistoryReportApp = Vue.createApp({})
	coreVisitHistoryReportApp.component('core-visit-history-report', CoreVisitHistoryReport)
	coreVisitHistoryReportApp.mount(coreVisitHistoryReportEl)
}

const noteListEl = document.querySelector('#note-list')
if (noteListEl) {
	const noteApp = Vue.createApp({}).use(store)
	noteApp.component('note-list', NoteList)
	noteApp.mount(noteListEl)
}

const schedulingReportEl = document.querySelector('#scheduling-report')
if (schedulingReportEl) {
	const schedulingReportApp = Vue.createApp({})
	schedulingReportApp.component('scheduling-report', SchedulingReport)
	schedulingReportApp.mount(schedulingReportEl)
}

const substudyDetailEl = document.querySelector('#substudy-detail')
if (substudyDetailEl) {
	const substudyApp = Vue.createApp({}).use(store)
	substudyApp.component('substudy-detail', SubstudyDetail)
	substudyApp.mount(substudyDetailEl)
}

const userListEl = document.querySelector('#users-list-container')
if (document.getElementById('users-list-container')) {
  	const usersApp = createApp({})
  	usersApp.component('user-list', UserList)
  	usersApp.mount(userListEl)
}